"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GraphandModelList_1 = __importDefault(require("../lib/GraphandModelList"));
const getModelListFromCache = (model, query) => {
    const cacheKey = model.getCacheKey(query);
    const cacheEntry = model._cache[cacheKey];
    if (!cacheEntry) {
        return;
    }
    const { rows, count } = cacheEntry;
    const cachedRows = rows.map((r) => model.get(r._id, false));
    if (!cachedRows.every(Boolean)) {
        return;
    }
    return new GraphandModelList_1.default({ model, count, query, rows: cachedRows });
};
exports.default = getModelListFromCache;
